<template>
    <div class="makeMoney">
        <div class="mkbox">
            <div class="flexboxfle-sb" v-if="!isApp">
                <div class="boxtit">
                    <i class="el-icon-s-finance fonts4"></i>
                    {{$t('menu.manageMoney')}}
                </div>
            </div>
            <div v-else>
                <div class="title acctit">
                    {{$t('menu.manageMoney')}}
                    <div class="addbtn btnn">
                        <el-popover
                                placement="bottom"
                                width="80"
                                trigger="click">
                            <div class="lanlist">
                                <div :class="lang==item.name?'activeList':''" @click="changlang(item.name, item)" v-for="(item, index) in langList" :key="index">
                                    <img :src="item.flag"/>{{item.full_name}}
                                </div>
                            </div>
                            <div slot="reference"><img :src="currentLang.flag"/>{{currentLang.full_name}}</div>
                        </el-popover>
                    </div>
                </div>
                <div>
                    <div class="flexbox lctitbox">
                        <img src="../assets/imgs/logo.png">
                        <div class="textl">
                            <div class="colory fontw">{{user.money}}<span class="minim"> ≈ ${{user.money}}</span></div>
                            <div>{{$t('account.balance')}}</div>
                            <div class="colory fontw posrbtn" v-if="!user.user_id" @click="$router.push({path: '/login'})">{{$t('account.login')}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isApp" class="titlelist">{{$t('index.products')}}</div>
            <div class="cplb">
                <div class="flexbox fle-sb fle-wrap">
                    <div class="itembox" @click="jumptolcdetail(item.id)" v-for="(item, index) in lists"
                         :key="index+'box'">
                        <div class="flexbox fle-sb tipitem">
                            <img :src="item.image">
                            <div class="fontwe appname">{{item.name}}</div>
                            <div class="appmaginw">{{item.days}}{{$t('index.day')}}</div>
                            <div class="apprbox">
                                <div class="fontwe">{{item.rate}}%</div>
                                <div>{{$t('index.unit')}}</div>
                            </div>
                        </div>
                        <div class="btnn bybtn">
                            {{$t('index.buy')}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Cookies from 'js-cookie'
    import {getList} from '@/api/product'

    export default {
        name: 'makeMoney',
        data() {
            return {
                user:{
                    user_id: -1,
                    money: '0.00',
                },
                lists: [],
                lang: Cookies.get('lang'),
                langList: [],
                currentLang: {},
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        created() {
            this.getData()
        },
        methods: {
            changlang(lang, item) {
                if(lang != this.lang){
                    this.lang = lang
                    this.currentLang = item
                    this.$i18n.locale = lang
                    Cookies.set('lang', lang)
                    Cookies.set('lang_var', item.lang_var)
                    this.$router.go(0)
                }
            },
            getData() {
                getList().then(res => {
                    const data = res.data
                    this.lists = data.lists
                    this.user = data.user
                    this.langList = res.data.langList
                    if(this.langList){
                        for(let index = 0; index < this.langList.length; index++){
                            let item = this.langList[index]
                            if(this.lang == item.name){
                                this.currentLang = item
                                break
                            }
                        }
                    }
                }).catch(_ => {

                })
            },
            jumptolcdetail(id) {
                this.$router.push({path: '/home/detail/' + id})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .makeMoney {
        width: 1200px;
        margin: 20px auto;
        min-height: calc(100vh - 290px);

        .mkbox {
            padding-top: 0px !important;
        }

        .addbtn {
            background: transparent !important;
        }

        .acctit {
            border-bottom: 0px;
            background: #000;

            .addbtn {
                top: 10px;
                background: #000 !important;
            }

            img {
                width: 30px;
                height: 20px;
                vertical-align: middle;
                margin-right: 6px;
            }
        }

        img {
            width: 50px;
            height: 20px;
            vertical-align: middle;
            margin-right: 6px;
        }

        .itembox {
            padding: 20px;
            margin: 20px 0px;
            width: 500px;
            box-sizing: border-box;
            border-radius: 10px;
            background: rgb(36, 36, 36);
            font-size: 30px;
            text-align: left;

            img {
                padding: 0px 20px 20px 0px;
                width: 100px;
                height: 100px;
                border-radius: 0px;
            }

            .bybtn {
                background: rgb(37, 23, 240);
                text-align: center;
                line-height: 60px;
            }

            .tipitem {
                & > div {
                    // margin: 20px 20px;
                }
            }
        }
    }
</style>
